export default {

    methods: {
        changePage(newPage) {
            this.filters.page = newPage
            this.updateList()
        },

        changeItemsPerPage(newItemsPerPage) {
            this.filters.perPage = newItemsPerPage;
            this.updateList()
        },

        updateList() {
            if (typeof this.getList === 'function') {
                this.getList(this.filters)
            } else {
                console.error("getList method is not defined in the component")
            }
        }
    }
}
